module.exports = __webpack_public_path__ + "5fe438ff866b63cb220cb1265bb70ac5.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/bg.png
// module id = ./app/images/bg.png
// module chunks = 40